import React, { useEffect } from "react";
import "./message.css";

const Message = ({ type = "info", text, icon, onClose, duration = 5000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <div className={`message message-${type}`}>
      {icon && <span className="message-icon">{icon}</span>}
      <span className="message-text">{text}</span>
      <button className="message-close" onClick={onClose}>✖</button>
    </div>
  );
};

export default Message;
